var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundTrafficMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 1740,
    viewBox: "0 0 425 1740",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8878 51.8165C44.0063 51.934 44.1665 52 44.3334 52C44.5003 52 44.6604 51.934 44.779 51.8165L95.3538 1.65402C97.5773 -0.55132 101.163 -0.551295 103.386 1.65407L153.959 51.8151C154.078 51.9335 154.239 52 154.408 52C154.576 52 154.737 51.9335 154.857 51.8151L205.43 1.65402C207.653 -0.551321 211.239 -0.551295 213.463 1.65407L264.036 51.8158C264.155 51.9338 264.315 52 264.483 52C264.65 52 264.811 51.9338 264.93 51.8158L315.504 1.65402C317.728 -0.55132 321.313 -0.551295 323.537 1.65407L374.11 51.8158C374.229 51.9338 374.389 52 374.557 52C374.725 52 374.885 51.9338 375.004 51.8158L425.578 1.65402C427.802 -0.55132 431.388 -0.551295 433.611 1.65407L474.799 42.5068C478.414 46.0929 475.875 52.2594 470.782 52.2594H430.704C427.554 52.2594 425 54.8129 425 57.9627V170V177.297V1739H424.999L424.999 1652L337.832 1739H0.000377655V177.297V170V57.9627C0.000377655 54.8129 -2.55309 52.2594 -5.70295 52.2594H-51.8907C-56.9831 52.2594 -59.5226 46.0928 -55.907 42.5067L-14.7185 1.65402C-12.495 -0.551321 -8.90922 -0.551295 -6.68578 1.65407L43.8878 51.8165Z",
    fill: "#CAFA44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M337.451 1739.38L337.451 1652L425 1652L337.451 1739.38Z",
    fill: "url(#paint0_linear_210_4040)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 276.5L100.5 176L-8.78599e-06 176L0 276.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5 276.5L201 176L100.5 176L100.5 276.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 377L100.5 276.5L-8.78599e-06 276.5L0 377Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M337 1652L250 1739L250 1652L337 1652Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M323 518L425 620L425 518L323 518Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 1675L32 1708.45L64 1675V1739H0V1675Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64 1675L96 1708.45L128 1675V1739H64V1675Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128 1675L160 1708.45L192 1675V1739H128V1675Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_210_4040",
    x1: 391.383,
    y1: 1704.43,
    x2: 337.45,
    y2: 1652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D7321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7EA28"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundTrafficMobile);
export default __webpack_public_path__ + "static/media/backgroundTrafficMobile.a9c4d76fcb138294042b45c0b3b8c900.svg";
export { ForwardRef as ReactComponent };